export default __webpack_public_path__ + "static/media/campus (1).0c9fc986.jpeg";